'use client';

import { createContext } from 'react';

import type { SharedSessionResponse } from '@/types/share-session';

export const ContextLogInfo = createContext<SharedSessionResponse | undefined>(undefined);

interface IProps {
  detailInfo: SharedSessionResponse;
  children: React.ReactNode;
}

function ProviderLogInfo(props: IProps): JSX.Element {
  const { detailInfo, children } = props;

  return <ContextLogInfo.Provider value={detailInfo}>{children}</ContextLogInfo.Provider>;
}

export default ProviderLogInfo;
